module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 27\".9e1b2d2d.png";